import { render, staticRenderFns } from "./NewSubTask.vue?vue&type=template&id=15214358&scoped=true&"
import script from "./NewSubTask.vue?vue&type=script&lang=js&"
export * from "./NewSubTask.vue?vue&type=script&lang=js&"
import style0 from "./NewSubTask.vue?vue&type=style&index=0&id=15214358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15214358",
  null
  
)

export default component.exports